import {store} from "../../../helper/store";
import {updateAppInstalledStatus} from "../../../action/gamma.state.action";

export const checkAppPermission = (app, gammaState) => {
	app.permission = gammaState.appsInstalled[app.id + "_installed"];
	if (app.permission === undefined)
		store.dispatch(updateAppInstalledStatus(app.id, app.defaultPermission || false));
	return app.permission;
}
